"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalAriaLabel = exports.ModalCloseMechanism = exports.ModalVariant = void 0;
var ModalVariant;
(function (ModalVariant) {
    ModalVariant["HALF_SLIDE"] = "half-slide-modal";
    ModalVariant["FULL_SLIDE"] = "full-slide-modal";
    ModalVariant["DEFAULT"] = "base-modal";
})(ModalVariant = exports.ModalVariant || (exports.ModalVariant = {}));
var ModalCloseMechanism;
(function (ModalCloseMechanism) {
    ModalCloseMechanism["BACKDROP_CLICK"] = "backdropClick";
    ModalCloseMechanism["ICON_CLICK"] = "iconClick";
    ModalCloseMechanism["ESCAPE_KEY_DOWN"] = "espcapeKeyDown";
})(ModalCloseMechanism = exports.ModalCloseMechanism || (exports.ModalCloseMechanism = {}));
var ModalAriaLabel;
(function (ModalAriaLabel) {
    ModalAriaLabel["id"] = "modal-title";
})(ModalAriaLabel = exports.ModalAriaLabel || (exports.ModalAriaLabel = {}));
